export const pageTypes = {
	content: 'content',
	cover: 'cover',
	coverEmpty: 'Cover Empty page'
};
